import React from 'react';
import { Link } from 'react-router-dom';
import { defaultListProps } from '~constants/config';
import { List, TextField, NumberField } from 'react-admin';
import CustomDatagrid from '~components/CustomDatagrid';
import ActionsField from '~components/ActionsField';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import IconButton from '@material-ui/core/IconButton';
import ArrowUpward from '@material-ui/icons/ArrowUpward';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import api from '~config/api';

function MoveButtons({ record }) {
  const handleMove = (direction) => {
    api.post(`/etapas/${record.id}/${direction}/`).then(() => {
      window.location.reload();
    });
  };

  return (
    <>
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleMove('move-up'); }}>
        <ArrowUpward fontSize="small" />
      </IconButton>
      <IconButton size="small" onClick={(e) => { e.stopPropagation(); handleMove('move-down'); }}>
        <ArrowDownward fontSize="small" />
      </IconButton>
    </>
  );
}

function EtapaListActions() {
  return (
    <CardActions>
      <Button color="primary" component={Link} to="/etapas/weights">
        Configurar pesos
      </Button>
    </CardActions>
  );
}

function EtapaList({ ...props }) {
  return (
    <List {...defaultListProps} {...props} sort={{ field: 'order', order: 'ASC' }} actions={<EtapaListActions />}>
      <CustomDatagrid rowClick="edit">
        <TextField source="nameEs" sortable={false} />
        <TextField source="nameEn" sortable={false} />
        <TextField source="namePt" sortable={false} />
        <NumberField source="weight" sortable={false} />
        <MoveButtons label="Orden" />
        <ActionsField />
      </CustomDatagrid>
    </List>
  );
}

export default EtapaList;
